import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../components/dashboard/Index'
import Login from '../components/user/Login'

import store from '@/store/index'

import ConfigurationRoutes from '@/components/configuration/routes'
import AgencyRoutes from '@/components/agency/routes'
import ProjectRoutes from '@/components/project/routes'
import ApartmentRoutes from '@/components/apartment/routes'
import KanbanRoutes from '@/components/kanban/routes'
import SaleRoutes from '@/components/sale/routes'
import ProspectRoutes from '@/components/prospects/routes'
import CalculatorRoutes from '@/components/calculator/routes'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      title: 'Dashboard',
      breadcrumb: 'Dashboard'
    },
    component: Dashboard
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login',
      bodyClass: 'login-container'
    },
    component: Login
  },
  ...ConfigurationRoutes,
  ...AgencyRoutes,
  ...ProjectRoutes,
  ...ApartmentRoutes,
  ...KanbanRoutes,
  ...SaleRoutes,
  ...ProspectRoutes,
  ...CalculatorRoutes
]

const router = new Router({
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.auth) && !store.getters.isLoggedIn) {
    router.replace({ name: 'login' })
  } else {
    next()
  }
})

export default router
